module.exports = __webpack_public_path__ + "media/images/stanford_on_broadway/Dec18_Broadway_SammiCannold-9805c6ae57ef53293bce2aca0cc3328c.png";